import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import './ErrorPage.css'

function ErrorPage({ history, statusCode, location }) {
  const { t } = useTranslation(['common'], {
    useSuspense: false,
  })
  const handleClick = () => {
    if (statusCode === 404) {
      const prevPage = location.pathname

      history.goBack()

      setTimeout(() => {
        if (location.pathname === prevPage) {
          window.location.assign('https://hollo.io')
        }
      }, 1000)
    } else {
      window.location.reload(false)
    }
  }

  return (
    <div id="error-page">
      <div className="error-page">
        <div className="background-image" />
        <h1>{statusCode || '404'}</h1>
        <h2>
          {statusCode === 400 && t('common:errorPage.badRequest.title')}
          {statusCode === 404 ||
            (statusCode === undefined && t('common:errorPage.notFound.title'))}
          {statusCode > 404 && t('common:errorPage.internalServer.title')}
        </h2>
        <p>
          {statusCode === 400 && t('common:errorPage.badRequest.description')}
          {statusCode === 404 ||
            (statusCode === undefined &&
              t('common:errorPage.notFound.description'))}
          {statusCode > 404 && t('common:errorPage.internalServer.description')}
        </p>
        <div className="button-wrapper">
          <Button color="link" onClick={handleClick}>
            {statusCode === 400 && t('common:errorPage.badRequest.description')}
            {statusCode === 404 && t('common:errorPage.backBtn')}
            {statusCode > 404 && t('common:errorPage.retryBtn')}
          </Button>
        </div>
      </div>
    </div>
  )
}

ErrorPage.propTypes = {
  history: PropTypes.shape(),
  location: PropTypes.shape(),
  statusCode: PropTypes.number.isRequired,
}

export default ErrorPage
